<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">{{ $t("macsSettings") }}</div>
    </div>

    <div class="white-wrapper my-3">
      <section class="mb-2 w-100 px-3 section-new">
        <div
          class="section-title mb-2 d-flex justify-content-between section-collapse-box"
          style="padding:6px;align-items: center;"
          v-b-toggle.organisation
        >
          <span class="fs">
            {{ $t("oganization") }}
          </span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse
          id="organisation"
          class="mt-2 "
          v-model="sectionCollapse.organisation"
        >
          <div class="pr-2 pl-2 pt-3 pb-0 new-border br-10 mx-auto back">
            <div
              class="row mb-1"
              v-for="(org, orgIndex) in OrganizationArray"
              :key="orgIndex"
            >
              <div class="d-flex align-items-center col-4 mb-4">
                <div class="input-material ">
                  <input
                    placeholder="."
                    disabled
                    type="text"
                    v-model="org.org_name"
                    v-b-tooltip.hover
                    :title="'Organization'"
                  />
                  <label>{{ "Organization" }}</label>
                </div>
                <!--Tooltip :title="'Organization'" /-->
              </div>
              <div class="d-flex align-items-center col-4 mb-4">
                <div class="input-material ">
                  <input
                    placeholder="."
                    type="text"
                    v-model="org.macsbox_cd"
                    v-b-tooltip.hover
                    :title="$t('maccs_box_cd')"
                  />
                  <label>{{ $t("maccs_box_cd") }}</label>
                </div>
                <!--Tooltip :title="$t('maccs_box_cd')" /-->
              </div>
              <div class="d-flex align-items-center col-4 mb-4">
                <div class="input-material ">
                  <input
                    placeholder="."
                    type="text"
                    v-model="org.territory_cd"
                    v-b-tooltip.hover
                    :title="'Territory CD'"
                  />
                  <label>{{ "Territory CD" }}</label>
                </div>
                <!--ooltip :title="'Territory CD'" /-->
              </div>
              <div class="d-flex align-items-center col-3 mb-4">
                <div class="input-material ">
                  <input
                    placeholder="."
                    type="text"
                    v-model="org.print_id"
                    v-b-tooltip.hover
                    :title="'Print ID'"
                    style="text-align:right;"
                  />
                  <label>{{ "Print ID" }}</label>
                </div>
                <!--Tooltip :title="'Print ID'" /-->
              </div>
              <div class="d-flex align-items-center col-3 mb-4">
                <div class="input-material ">
                  <input
                    placeholder="."
                    type="text"
                    v-model="org.figure_type_cd"
                    style="text-align:right;"
                    v-b-tooltip.hover
                    :title="'Figure Type ID'"
                  />
                  <label>{{ "Figure Type ID" }}</label>
                </div>
                <!--Tooltip :title="'Figure Type ID'" /-->
              </div>
              <div class="d-flex align-items-center col-3 mb-4">
                <div class="input-material ">
                  <input
                    placeholder="."
                    type="text"
                    v-model="org.free_admissions"
                    style="text-align:right;"
                    v-b-tooltip.hover
                    :title="'Free Admissions'"
                  />
                  <label>{{ "Free Admissions" }}</label>
                </div>
                <!--Tooltip :title="'Free Admissions'" /-->
              </div>
              <div class="d-flex align-items-center col-3 mb-4">
                <div class="input-material ">
                  <input
                    placeholder="."
                    type="text"
                    v-model="org.serial_start"
                    style="text-align:right;"
                    v-b-tooltip.hover
                    :title="'Serial Start'"
                  />
                  <label>{{ "Serial Start" }}</label>
                </div>
                <!--Tooltip :title="'Serial Start'" /-->
              </div>
              <div class="d-flex align-items-center col-3 mb-3">
                <div class="input-material ">
                  <input
                    placeholder="."
                    type="text"
                    v-model="org.serial_end"
                    style="text-align:right;"
                    v-b-tooltip.hover
                    :title="'Serial End'"
                  />
                  <label>{{ "Serial End" }}</label>
                </div>
                <!--Tooltip :title="'Serial End'" /-->
              </div>
              <div class="d-flex align-items-center col-3 mb-3">
                <div class="input-material ">
                  <input
                    placeholder="."
                    type="text"
                    v-model="org.params"
                    style="text-align:right;"
                    v-b-tooltip.hover
                    :title="'Params'"
                  />
                  <label>{{ "Params" }}</label>
                </div>
                <!--Tooltip :title="'Params'" /-->
              </div>
              <div class="d-flex align-items-center col-3 mb-3">
                <div class="input-material ">
                  <input
                    placeholder="."
                    type="text"
                    v-model="org.exhibitor_name"
                    v-b-tooltip.hover
                    :title="'Exhibitor Name'"
                  />
                  <label>{{ "Exhibitor Name" }}</label>
                </div>
                <!--Tooltip :title="'Exhibitor Name'" /-->
              </div>
              <div class="d-flex align-items-center col-3 mb-3">
                <div class="input-material ">
                  <input
                    placeholder="."
                    type="text"
                    v-model="org.exhibitor_id"
                    v-b-tooltip.hover
                    :title="'Exhibitor ID'"
                  />
                  <label>{{ "Exhibitor ID" }}</label>
                </div>
                <!--Tooltip :title="'Exhibitor ID'" /-->
              </div>
            </div>
          </div>
        </b-collapse>
      </section>
      <section class="mb-2 w-100 px-3 section-new">
        <div
          class="section-title mb-2 d-flex justify-content-between section-collapse-box"
          style="padding:6px;align-items: center;"
          v-b-toggle.cinema
        >
          <span class="fs">
            {{ $tc("cinema", 2) }}
          </span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse id="cinema" class="mt-2" v-model="sectionCollapse.cinema">
          <div class="pr-2 pl-2 pt-3 pb-0 new-border br-10 mx-auto back">
            <div
              class="row mb-2"
              v-for="(cinema, cinemaIndex) in cinemaArray"
              :key="cinemaIndex"
            >
              <div class="d-flex align-items-center col-4 mb-2">
                <div class="input-material ">
                  <input
                    placeholder="."
                    disabled
                    type="text"
                    v-model="cinema.cinema_name"
                    v-b-tooltip.hover
                    :title="'Cinema'"
                  />
                  <label>{{ "Cinema" }}</label>
                </div>
                <!--Tooltip :title="'Cinema'" /-->
              </div>
              <div class="d-flex align-items-center col-4 mb-2">
                <!-- <div>Cinema ID:</div> -->
                <div class="input-material ">
                  <input
                    placeholder="."
                    type="text"
                    v-model="cinema.cinema_macs_id"
                    style="text-align:right;"
                    v-b-tooltip.hover
                    :title="'Cinema ID'"
                  />
                  <label>{{ "ID" }}</label>
                </div>
                <!--Tooltip :title="'Cinema ID'" /-->
              </div>
              <div class="d-flex align-items-center col-4 mb-2">
                <!-- <div>Cinema CD:</div> -->
                <div class="input-material">
                  <input
                    placeholder="."
                    type="text"
                    v-model="cinema.cinema_cd"
                    style="text-align:right;"
                    v-b-tooltip.hover
                    :title="'Cinema CD'"
                  />
                  <label>{{ "CD" }}</label>
                </div>
                <!--Tooltip :title="'Cinema CD'" /-->
              </div>
            </div>
          </div>
        </b-collapse>
      </section>
      <section class="mb-2 w-100 px-3 section-new">
        <div
          class="section-title mb-2 d-flex justify-content-between section-collapse-box"
          style="padding:6px;align-items: center;"
          v-b-toggle.distributor
        >
          <span class="fs">
            {{ $tc("distributor", 2) }}
          </span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse
          id="distributor"
          class="mt-2"
          v-model="sectionCollapse.distributor"
        >
          <div class="pr-2 pl-2 pt-3 pb-3 new-border br-10 mx-auto back">
            <div class="d-flex justify-content-between">
              <div class="w-25 mb-3">
                <b-form-input
                  v-debounce:500="onSearchDistributor"
                  v-model="DistributorSearchValue"
                  placeholder="Search..."
                ></b-form-input>
              </div>
              <div class="mx-2">
                <!-- <div class="mx-auto">
                  <button
                    @click.prevent.stop="saveAllMovies()"
                    class="btn-blue"
                  >
                    {{ $t("save") }} {{ "All" }}
                  </button>
                </div> -->
              </div>
            </div>
            <div
              class="row mb-4"
              v-for="(distributor, distributorIndex) in DistributorArray"
              :key="distributorIndex"
            >
              <div class="d-flex align-items-center col-3">
                <div class="input-material">
                  <input
                    placeholder="."
                    disabled
                    type="text"
                    v-model="distributor.distributor_name"
                    v-b-tooltip.hover
                    :title="'Distributor'"
                  />
                  <label>{{ "Distributor" }}</label>
                </div>
                <!--Tooltip :title="'Distributor'" /-->
              </div>
              <div
                class="d-flex align-items-center col-5 px-1"
                style="gap: 15px;"
              >
                <div class="d-flex align-items-center">
                  <!-- <div>Distrubtor ID:</div> -->
                  <div class="input-material">
                    <input
                      placeholder="."
                      type="text"
                      v-model="distributor.distributor_macs_id"
                      style="text-align:right;"
                      v-b-tooltip.hover
                      :title="$t('distributor_maccs_id')"
                    />
                    <label>{{ $t("macsId") }}</label>
                  </div>
                  <!--Tooltip :title="$t('distributor_maccs_id')" /-->
                </div>
                <div class="d-flex align-items-center">
                  <!-- <div>Distrubtor CD:</div> -->
                  <div class="input-material">
                    <input
                      placeholder="."
                      type="text"
                      v-model="distributor.distributor_cd"
                      style="text-align:right;"
                      v-b-tooltip.hover
                      :title="'Distributor CD'"
                    />
                    <label>{{ "CD" }}</label>
                  </div>
                  <!--Tooltip :title="'Distributor CD'" /-->
                </div>
                <div class="d-flex align-items-center">
                  <!-- <div>Contract CD:</div> -->
                  <div class="input-material">
                    <input
                      placeholder="."
                      type="text"
                      v-model="distributor.contract_cd"
                      style="text-align:right;"
                      v-b-tooltip.hover
                      :title="'Contract CD'"
                    />
                    <label>{{ "Contract CD" }}</label>
                  </div>
                  <!--Tooltip :title="'Contract CD'" /-->
                </div>
              </div>

              <div class="col-4 p-0 pl-2 d-flex align-items-center">
                <div class="" style="zoom: 0.8;font-size: 14px;">
                  <!-- <label class="mb-0">FDS member</label> -->
                  <div class="d-flex align-items-center">
                    <b-form-radio
                      :value="'Y'"
                      class="j-radio"
                      v-model="distributor.member_of_fds"
                    >
                      <div>
                        <span>{{ "FDS member" }}</span>
                      </div>
                    </b-form-radio>
                    <strong class="mx-3">OR</strong>

                    <b-form-radio
                      :value="'N'"
                      class="j-radio"
                      v-model="distributor.member_of_fds"
                    >
                      <div>
                        <span>{{ "Participating without being member" }}</span>
                      </div>
                    </b-form-radio>
                  </div>
                </div>

                <!-- <div class="pb-2" style="zoom:0.8">
                  <label class="mb-0">Participating without being member</label>
                 <div class="d-flex align-items-center">
                    <b-form-radio
                      :value="'Y'"
                      class="j-radio"
                      v-model="distributor.participating_in_maccsbox_without_being_member"
                    >
                      <div>
                        <span>{{ "YES" }}</span>
                      </div>
                    </b-form-radio>
                    <strong class="mx-3">OR</strong>

                    <b-form-radio
                      :value="'N'"
                      class="j-radio"
                      v-model="distributor.participating_in_maccsbox_without_being_member"
                    >
                      <div>
                        <span>{{ "No" }}</span>
                      </div>
                    </b-form-radio>
                </div>
              </div> -->
              </div>
            </div>
            <div class="row" v-if="showLoadMore && isDLoadMore">
              <div class="mx-auto">
                <button @click.prevent.stop="loadMoreD()" class="btn-blue">
                  {{ $t("Load") }} {{ "More" }}
                </button>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>
      <section class="mb-2 w-100 px-3 section-new">
        <div
          class="section-title mb-2 d-flex justify-content-between section-collapse-box"
          style="padding:6px;align-items: center;"
          v-b-toggle.ticketType
        >
          <span class="fs">
            {{ $t("Ticket Type") }}
          </span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse
          id="ticketType"
          class="mt-2"
          v-model="sectionCollapse.ticketType"
        >
          <div class="pr-2 pl-2 pt-3 pb-0 new-border br-10 mx-auto back">
            <div
              class="row mb-2"
              v-for="(tt, ttIndex) in TicketTypeArray"
              :key="ttIndex"
            >
              <div class="d-flex align-items-center col-4">
                <div class="input-material ">
                  <input
                    placeholder="."
                    disabled
                    type="text"
                    v-model="tt.tt_name"
                    v-b-tooltip.hover
                    :title="'Ticket Type'"
                  />
                  <label>{{ "Ticket Type" }}</label>
                </div>
                <!--Tooltip :title="'Ticket Type'" /-->
              </div>
              <div class="d-flex align-items-center col-4">
                <!-- <div>Distrubtor ID:</div> -->
                <div class="input-material ">
                  <input
                    placeholder="."
                    type="text"
                    v-model="tt.ticketTypeCd"
                    style="text-align:right;"
                    v-b-tooltip.hover
                    :title="'Ticket Type CD'"
                  />
                  <label>{{ "CD" }}</label>
                </div>
                <!--Tooltip :title="'Ticket Type CD'" /-->
              </div>
              <div class="d-flex align-items-center col-4">
                <!-- <div>Distrubtor CD:</div> -->
                <div class="input-material ">
                  <input
                    placeholder="."
                    type="text"
                    v-model="tt.ticketTypeDescription"
                    v-b-tooltip.hover
                    :title="'Ticket Type Description'"
                  />
                  <label>{{ "Description" }}</label>
                </div>
                <!--Tooltip :title="'Ticket Type Description'" /-->
              </div>
            </div>
          </div>
        </b-collapse>
      </section>
      <section class="mb-2 w-100 px-3 section-new">
        <div
          class="section-title mb-2 d-flex justify-content-between section-collapse-box"
          style="padding:6px;align-items: center;"
          v-b-toggle.screen
        >
          <span class="fs">
            {{ $t("Screens") }}
          </span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse id="screen" class="mt-2" v-model="sectionCollapse.screen">
          <div class="pr-2 pl-2 pt-3 pb-2 new-border br-10 mx-auto back">
            <div class="d-flex justify-content-between">
              <div class="w-25 mb-3 ">
                <b-form-input
                  v-debounce:500="onSearchScreen"
                  v-model="ScreenSearchValue"
                  placeholder="Search..."
                ></b-form-input>
              </div>
              <div class="mx-2"></div>
            </div>
            <div
              class="row mb-2"
              v-for="(screen, screenIndex) in ScreensArray"
              :key="screenIndex"
            >
              <div class="d-flex align-items-center col-4">
                <div class="input-material ">
                  <input
                    placeholder="."
                    disabled
                    type="text"
                    v-model="screen.screen_name"
                    v-b-tooltip.hover
                    :title="'Screen Name'"
                  />
                  <label>{{ $t("Screens") }}</label>
                </div>
                <!--Tooltip :title="'Screen Name'" /-->
              </div>
              <div class="d-flex align-items-center col-4">
                <!-- <div>Distrubtor ID:</div> -->
                <div class="input-material ">
                  <input
                    placeholder="."
                    disabled
                    type="text"
                    v-model="screen.cinema_name"
                    v-b-tooltip.hover
                    :title="'Cinema'"
                  />
                  <label>{{ "Cinema" }}</label>
                </div>
                <!--Tooltip :title="'Cinema'" /-->
              </div>
              <div class="d-flex align-items-center col-4">
                <!-- <div>Distrubtor CD:</div> -->
                <div class="input-material ">
                  <input
                    placeholder="."
                    type="text"
                    v-model="screen.screen_number_macs"
                    style="text-align:right;"
                    v-b-tooltip.hover
                    :title="'Screen Number'"
                  />
                  <label>{{ "Number" }}</label>
                </div>
                <!--Tooltip :title="'Screen Number'" /-->
              </div>
            </div>
            <div class="row" v-if="showLoadMore && isSLoadMore">
              <div class="mx-auto">
                <button @click.prevent.stop="loadMoreS()" class="btn-blue">
                  {{ $t("Load") }} {{ "More" }}
                </button>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>
      <section v-if="true" class="mb-4 w-100 px-3 section-new">
        <div
          class="section-title mb-3 d-flex justify-content-between section-collapse-box"
          style="padding:6px;align-items:center"
          v-b-toggle.movies
        >
          <span class="fs">
            {{ $tc("movie", 2) }}
          </span>
          <button type="button" class="btn-transparent chevron">
            <img
              src="@/assets/img/icons/primary/chevron-down.svg"
              height="24"
              width="24"
            />
          </button>
        </div>
        <b-collapse id="movies" class="mt-2" v-model="sectionCollapse.movies">
          <div class="pr-2 pl-2 pt-3 pb-2 new-border br-10 mx-auto back">
            <div class="d-flex justify-content-between">
              <div class="w-25 mb-3 ">
                <b-form-input
                  v-debounce:500="onSearchMovie"
                  v-model="MovieSearchValue"
                  placeholder="Search..."
                ></b-form-input>
              </div>
              <!-- <div class="mx-2">
                <div class="mx-auto">
                  <button
                    @click.prevent.stop="saveAllMovies()"
                    class="btn-blue"
                  >
                    {{ $t("save") }} {{ "All" }}
                  </button>
                </div>
              </div> -->
            </div>

            <table class="swc-report-table mb-3" border="1">
              <thead>
                <th style="width:80px">{{ $tc("Sr. No.") }}</th>
                <th>{{ $tc("Movie Name") }}</th>
                <th style="width:130px">{{ $tc("Maccs Status") }}</th>
              </thead>
              <tbody
                v-for="(movie, movieIndex) in MovieFilteredArray"
                :key="movieIndex"
                class="light_grey_back"
              >
                <tr class="py-3 ">
                  <td style="text-align:right">{{ movieIndex + 1 }}</td>
                  <td>
                    <div class="input-material">
                      <input
                        placeholder="."
                        disabled
                        type="text"
                        :title="movie.movie_name"
                        v-model="movie.movie_name"
                        v-b-tooltip.hover
                        title="Movie Title"
                      />
                      <!--label>{{ "Movie Title" }}</label-->
                    </div>
                  </td>
                  <td style="">
                    <b-form-checkbox
                      style="padding-bottom:0px;"
                      class="mb-0 j-checkbox pb-0"
                      name="check-button"
                      value="Y"
                      unchecked-value="N"
                      @change="pushToUpdateArray(movie)"
                      v-model="movie.macs_status"
                    ></b-form-checkbox>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="row mb-4">
              <div
                v-if="false"
                class="d-flex align-items-center col-6 mb-4 justify-content-center"
                v-for="(movie, movieIndex) in MovieFilteredArray"
                :key="movieIndex"
              >
                <div
                  style="background-color:white;flex-wrap:wrap"
                  class="d-flex py-2 br-10 align-items-center new-border"
                >
                  <div class="input-material col-7">
                    <input
                      placeholder="."
                      disabled
                      type="text"
                      :title="movie.movie_name"
                      v-model="movie.movie_name"
                      v-b-tooltip.hover
                      title="Movie Title"
                    />
                    <label>{{ "Movie Title" }}</label>
                  </div>
                  <label class="mr-2 mb-0">{{ $t("maccs_status") }}</label>
                  <b-form-checkbox
                    class="mb-0 j-checkbox  "
                    name="check-button"
                    value="Y"
                    unchecked-value="N"
                    @change="pushToUpdateArray(movie)"
                    v-model="movie.macs_status"
                  ></b-form-checkbox>
                  <!--Tooltip :title="'Movie Title'" /-->
                </div>
              </div>
              <!--div
                class="d-flex align-items-end justify-content-end col-7 mb-4 pr-5"
              >
                
              </div-->
            </div>
            <div class="row" v-if="showLoadMore && isLoadMore">
              <div class="mx-auto">
                <button @click.prevent.stop="loadMore()" class="btn-blue">
                  {{ $t("Load") }} {{ "More" }}
                </button>
              </div>
            </div>
          </div>
        </b-collapse>
      </section>

      <div
        class="text-center"
        v-if="
          $can('create', 'MACCS Settings') || $can('update', 'MACCS Settings')
        "
      >
        <button @click.prevent.stop="finalSubmit()" class="btn-blue">
          {{ $t("save") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import scheduleService from "@/services/scheduleService";
  import MovieService from "@/services/MovieService";
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        Cinemas: [],
        cinemaArray: [],
        MovieArray: [],
        Movies: [],
        Screens: [],
        ScreensArray: [],
        TicketTypes: [],
        TicketTypeArray: [],
        sectionCollapse: {
          organisation: false,
          cinema: false,
          movies: false,
          distributor: false,
          ticketType: false,
          screen: false,
        },
        MaccsboxCd: "",
        MovieRows: null,
        MovieSelectedValue: "5",
        MoviePerPage: 1000,
        MovieCurrentPage: 1,
        totalMovieCount: 0,
        totalMovies: 0,
        showLoadMore: true,
        MovieSearchValue: "",
        Distributors: [],
        DistributorArray: [],
        Organization: [],
        OrganizationArray: [],
        DistributorPerPage: 5,
        DistributorCurrentPage: 1,
        DistributorSearchValue: "",
        DistributorSearchKey: "d_company_name",
        DistributorRows: null,
        totalDistributors: 0,
        MovieUpdateArray: [],
        MovieArrIndex: {},
        ScreenPerPage: 5,
        ScreenCurrentPage: 1,
        ScreenSearchValue: "",
        ScreenSearchKey: "screen_name",
        ScreenRows: null,
        totalScreen: 0,
        moviesearchKeys:
          "movie_title,movie_unique_identifier,alternate_movie_name_language,g_name,d_company_name,mcc_cast_name",
      };
    },
    computed: {
      MovieFilteredArray() {
        let limit = this.MoviePerPage * this.MovieCurrentPage;
        return this.MovieArray.slice(0, limit);
      },
      isLoadMore() {
        if (
          this.MovieArray.length >= this.totalMovies ||
          this.MovieArray.length == 0
        ) {
          return false;
        } else {
          return true;
        }
      },
      isDLoadMore() {
        if (
          this.DistributorArray.length >= this.totalDistributors ||
          this.DistributorArray.length == 0
        ) {
          return false;
        } else {
          return true;
        }
      },
      isSLoadMore() {
        if (
          this.ScreensArray.length >= this.totalScreen ||
          this.ScreensArray.length == 0
        ) {
          return false;
        } else {
          return true;
        }
      },
    },
    watch: {},
    beforeMount() {
      this.getCinemasList();
      this.getAllActiveMovies();
      // this.getMovies();
      this.getDistributorList();
      this.getOrganization();
      this.getTicketTypeList();
      this.getScreens();
    },
    mounted() {},
    methods: {
      pushToUpdateArray(movie) {
        console.log("i am running on blur");
        var index = this.MovieArrIndex[movie.md_id];
        if (index === undefined) {
          index = this.MovieUpdateArray.length;
          this.MovieArrIndex[movie.md_id] = index;
        }
        this.MovieUpdateArray[index] = movie;
      },
      finalSubmit() {
        let finalObj = {
          Organisation: this.OrganizationArray,
          Distributor: this.DistributorArray,
          Cinemas: this.cinemaArray,
          Movies: this.MovieUpdateArray,
          TicketType: this.TicketTypeArray,
          Screens: this.ScreensArray,
        };
        console.log("finalObj", finalObj);
        MasterService.UpdateMacsSettings(finalObj)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.$toasted.show("Maccs Settings SuccessFully Updated!");
              this.$router.push("/");
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      },
      saveAllMovies() {
        console.log("Final Movie Array", this.MovieUpdateArray);
        console.log("SAve Movie Clicked");
      },
      getTicketTypeList: function() {
        this.TicketTypes = [];
        let body = {
          tableName: "ms_ticket_type",
          tt_is_active: "Y",
        };
        MasterService.GetActiveList(body)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.TicketTypes = data.Records.filter((x) => {
                return x.tt_is_active == "Y";
              });
              data.Records.map((x) => {
                let Obj = {
                  tt_id: x.tt_id,
                  tt_name: x.tt_name,
                  ticketTypeCd: x.ticket_type_macs_cd,
                  ticketTypeDescription: x.ticket_type_macs_description,
                };
                this.TicketTypeArray.push(Obj);
              });
            } else {
              this.$toasted.show(data.message || "Opps! Something went wrong");
            }
          })
          .catch(this._CatchError);
      },
      getDistributorList(isSearch = false) {
        let body = {
          limit: this.DistributorPerPage,
          currentPage: this.DistributorCurrentPage,
          searchValue: this.DistributorSearchValue,
          searchKey: this.DistributorSearchKey,
        };
        if (isSearch) {
          this.DistributorArray = [];
        }
        MasterService.GetAllDistributors(body)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Distributors = data.Records;
              this.totalDistributors = data.totalRows ? data.totalRows : 0;
              if (data.totalRows && data.totalRows >= 10) {
                this.DistributorRows = data.totalRows;
              } else {
                this.DistributorRows = data.totalRows ? data.totalRows : 0;
              }
              data.Records.map((x) => {
                let Obj = {
                  distributor_id: x.d_id,
                  distributor_name: x.d_company_name,
                  distributor_cd: x.distributor_macs_cd,
                  contract_cd: x.contract_macs_cd,
                  distributor_macs_id: x.distributor_macs_id,
                  member_of_fds: x.member_of_fds,
                  participating_in_maccsbox_without_being_member:
                    x.participating_in_maccsbox_without_being_member,
                };
                this.DistributorArray.push(Obj);
              });
            } else {
              console.log("Error: No Records Found");
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      },
      getOrganization() {
        MasterService.GetMacsOrganisation()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Organization = data.Records;
              data.Records.map((x) => {
                let Obj = {
                  oml_id: x.oml_id || null,
                  macsbox_cd: x.macs_box_cd,
                  org_name: x.org_name,
                  org_id: x.org_id,
                  territory_cd: x.territory_cd,
                  print_id: x.print_id,
                  figure_type_cd: x.figure_type_cd,
                  free_admissions: x.free_admissions,
                  serial_start: x.serial_start,
                  serial_end: x.serial_end,
                  params: x.params,
                  exhibitor_name: x.exhibitor_name,
                  exhibitor_id: x.exhibitor_id,
                };
                this.OrganizationArray.push(Obj);
              });
            } else {
              console.log("Error: No Records Found");
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      },
      getScreens(isSearch = false) {
        let payload = {
          limit: this.ScreenPerPage,
          currentPage: this.ScreenCurrentPage,
          searchValue: this.ScreenSearchValue,
          searchKey: this.ScreenSearchKey,
        };
        if (isSearch) {
          this.ScreensArray = [];
        }
        MasterService.GetAllScreens(payload).then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Screens = data.Records;
            this.totalScreen = data.totalRows ? data.totalRows : 0;
            if (data.totalRows && data.totalRows >= 10) {
              this.ScreenRows = data.totalRows;
            } else {
              this.ScreenRows = data.totalRows ? data.totalRows : 0;
            }
            data.Records.map((x) => {
              let Obj = {
                screen_id: x.screen_id,
                screen_name: x.screen_name,
                cinema_name: x.cine_name,
                screen_number_macs: x.screen_number_macs,
              };
              this.ScreensArray.push(Obj);
            });
          } else {
            console.log("data.message", data.message);
          }
        });
      },
      onSearchMovie: function() {
        this.MovieCurrentPage = 1;
        this.getAllActiveMovies(true);
        // this.getMovies(true);
      },
      onSearchDistributor: function() {
        this.DistributorCurrentPage = 1;
        this.getDistributorList(true);
      },
      onSearchScreen: function() {
        this.ScreenCurrentPage = 1;
        this.getScreens(true);
      },
      loadMore() {
        this.MovieCurrentPage++;
        this.getAllActiveMovies();
        // this.getMovies();
      },
      loadMoreD() {
        this.DistributorCurrentPage++;
        this.getDistributorList();
      },
      loadMoreS() {
        this.ScreenCurrentPage++;
        this.getScreens();
      },
      getMovies(isSearch = false) {
        let loader = this.$loading.show();
        if (isSearch) {
          this.MovieArray = [];
        }
        MovieService.GetMovies2({
          limit: this.MoviePerPage,
          currentPage: this.MovieCurrentPage,
          searchValue: this.MovieSearchValue,
          searchKey: this.moviesearchKeys,
          columnName: "created_at",
          orderBy: "desc",
          status: "active",
          region_id: null,
        })
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.Movies = data.Records;
              this.totalMovies = data.totalRows ? data.totalRows : 0;
              if (data.totalRows && data.totalRows >= 10) {
                this.MovieRows = data.totalRows;
                if (data.Records.length < 10) {
                  this.MovieSelectedValue = data.Records.length;
                }
              } else {
                this.MovieRows = data.totalRows ? data.totalRows : 0;
                this.MovieSelectedValue = data.totalRows
                  ? data.totalRows
                  : this.MoviePerPage;
              }
              data.Records.map((x) => {
                let obj = {
                  movie_name: x.movie_title,
                  movie_id: x.movie_id,
                  macs_status: x.macs_status || "Y",
                };
                this.MovieArray.push(obj);
              });
              this.MoviesCopy = this.MovieArray;
            } else {
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          })
          .finally(() => {
            loader.hide();
          });
      },
      getAllActiveMovies: function(isSearch = false) {
        let loader = this.$loading.show();
        let payload = {
          limit: this.MoviePerPage,
          currentPage: this.MovieCurrentPage,
          schedule: this.MovieSearchValue,
        };
        if (isSearch) {
          this.MovieArray = [];
        }
        scheduleService
          .GetMovies(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.MovieListResult.length > 0) {
              this.Movies = data.MovieListResult;
              this.totalMovies = data.totalRows ? data.totalRows : 0;
              if (data.totalRows && data.totalRows >= 10) {
                this.MovieRows = data.totalRows;
                if (data.MovieListResult.length < 10) {
                  this.MovieSelectedValue = data.MovieListResult.length;
                }
              } else {
                this.MovieRows = data.totalRows ? data.totalRows : 0;
                this.MovieSelectedValue = data.totalRows
                  ? data.totalRows
                  : this.MoviePerPage;
              }
              data.MovieListResult.map((x) => {
                let obj = {
                  movie_name: this.getMovieVersionText(x),
                  md_id: x.md_id,
                  movie_id: x.movie_id,
                  macs_status: x.macs_status || "Y",
                };
                this.MovieArray.push(obj);
              });
              this.MoviesCopy = this.MovieArray;
            } else {
              // Show Message Here:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            console.log("Catch Error on getAllActiveMovies :", error);
          })
          .finally(() => {
            loader.hide();
          });
      },
      getMovieVersionText(movie) {
        let temp_arr = [];
        if (movie.movie_title) temp_arr.push(movie.movie_title);
        if (movie.mf_name) temp_arr.push(movie.mf_name);
        if (movie.lang_iso_2) temp_arr.push(movie.lang_iso_2);
        if (movie.sound_format_name) temp_arr.push(movie.sound_format_name);
        if (movie.resolution_short_code)
          temp_arr.push(movie.resolution_short_code);
        if (movie.aspect_ratio_name) temp_arr.push(movie.aspect_ratio_name);
        if (movie.movie_experience) temp_arr.push(movie.movie_experience);
        if (movie.sub_lang_1_iso_2) temp_arr.push(movie.sub_lang_1_iso_2);
        if (movie.sub_lang_2_iso_2) temp_arr.push(movie.sub_lang_2_iso_2);

        if (temp_arr.length > 0) {
          return temp_arr.join("-").toUpperCase();
        } else {
          return "";
        }
      },
      getCinemasList: function() {
        this.Cinemas = [];
        MasterService.GetCinemas()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              data.Records.map((x) => {
                let obj = {
                  cinema_id: x.cine_id,
                  cinema_name: x.cine_name,
                  cinema_cd: x.cinema_macs_cd,
                  cinema_macs_id: x.cinema_macs_id,
                };
                this.cinemaArray.push(obj);
              });
              console.log("this.cinemaArray", this.cinemaArray);
            } else {
              this.$$toasted.show(data.message);
              console.log("show error :", data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      },
      handleCollapse(content) {
        content.isCollapsed = !content.isCollapsed;
      },
      onChangeTabHandler: function(event, index) {
        this.activeClass = index;
      },
    },
  };
</script>
<style>
  .section-collapse-box {
    border: 1px solid var(--lightgrey);
    border-radius: 10px;
    padding: 10px;
  }

  .section-new .section-title {
    font-size: 22px;
  }

  .cms_header_image {
    max-width: 400px;
  }

  .br-10 {
    border-radius: 10px;
  }
  .new-border {
    border: 2px solid #b1b4b8;
  }
  label {
    color: black !important;
  }
  .internal-border-new {
    border: 1px solid #3876d2;
    /*background-color: #e6e6f8;*/
  }
  .internal-border {
    border: 1px solid #3876d2;
    background-color: #e6e6f8;
    display: flex;
    flex-wrap: wrap;
    border-radius: 10px;
    margin: 0 15px 15px 15px;
    padding-top: 15px;
  }
  .fs {
    font-size: 17px;
  }
  .back {
    background-color: #f5f5f5;
  }
  .mar {
    margin-left: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/Macs/macsSettings.vue